import React, { useState, useEffect } from "react";
import PropTypes from 'prop-types';
import { Card, Button, MaxModal, Heading } from "@maxmilhas/hangar-components-atomic/public";
import { css } from 'emotion';
import CancellationForm from "./organisms/CancellationForm";
import SpecialCancellationForm from "./organisms/SpecialCancellationForm";

const buttonCustomStyle = `
    margin-top: 15px;
    border: 0;
    max-width: 265px;
    height: 48px;
    box-shadow: none !important;
`

const listItemStyle = `
    color: #223254;
    font-weight: 600;
`

const linkStyle = `
    color: #1abc9c !important;
    text-decoration: underline;
    font-weight: 600;
`

const CancellationProtocol = ({ order, title, isCorona, noShow, showAlertModal, isAfterCiaDate }) => {
    const [isFormOpen, setIsFormOpen] = useState(false);
    const [isModalOpen, setModalOpen] = useState(false);
    
    let rules = order.cancellationProtocolRules;

    if (isCorona) {
        const onlyCoronaRule = { 'corona': { ...rules.corona }};
                
        if(!order.isOTA && order.flights.outbound.airline == "Gol"){
            delete onlyCoronaRule.corona.choices.reschedule
        } 
        
        rules = onlyCoronaRule;
    } else {
        delete rules.corona;
    }

    useEffect(() => {
        const body = document.querySelector('body');

        body.style.overflow = isFormOpen ? 'hidden' : '';
    }, [isFormOpen])

    const handleForm = () => {
        setIsFormOpen(!isFormOpen);
    };

    return(
        <>
            <Card
                title={"Cancelamento e remarcação por Coronavírus (COVID-19) Para voos até " + title}
                selfOpenControl={!isCorona}
                type='accordion'
                onClick={() => {
                    if (isCorona) {
                        if (showAlertModal) {
                            setModalOpen(true);
                        } else {
                            handleForm();
                        }
                    }
                }}
        >
                { !isAfterCiaDate && (
                    <>
                        <p>As companhias aéreas avaliam a possibilidade de alteração na passagem e isenção das taxas de cancelamento ou remarcação nos seguintes casos:</p>

                        <ul>
                            <li className={css`${listItemStyle}`}><p>Alteração da data de concurso público ou grandes eventos</p></li>
                            <li className={css`${listItemStyle}`}><p>Alteração involuntária por parte da companhia</p></li>
                            <li className={css`${listItemStyle}`}><p>Correção de letra do nome e do sobrenome</p></li>
                            <li className={css`${listItemStyle}`}><p>Doença infectocontagiosa do viajante</p></li>
                            <li className={css`${listItemStyle}`}><p>Reserva duplicada</p></li>
                            <li className={css`${listItemStyle}`}><p>Óbito do viajante ou de parente de primeiro grau</p></li>
                        </ul>

                        <p>Vale lembrar que as solicitações estão sujeitas à avaliação de cada companhia aérea.</p>

                        <p><a className={css`${linkStyle}`} target="_blank" href='https://ajuda.maxmilhas.com.br/hc/pt-br/sections/360005600893-Remarca%C3%A7%C3%A3o-e-Cancelamento'>Saiba mais sobre cada alteração.</a></p>

                        <Button
                            size="medium"
                            className={css`${buttonCustomStyle}`}
                            onClick={handleForm}
                        >
                            Solicitar alteração
                        </Button>
                    </>
                )}

            </Card>

            {isFormOpen && !isAfterCiaDate && <CancellationForm order={order} protocolData={rules} closeForm={handleForm} isCorona={isCorona} title={"Cancelamento e remarcação por Coronavírus (COVID-19) Para voos até " + title} noShow={noShow}/>}
            {isFormOpen && isAfterCiaDate && <SpecialCancellationForm order={order} closeForm={handleForm} limitDate={title}/>}

            <MaxModal open={isModalOpen} onClose={() => setModalOpen(false)}>
                <>
                    <Heading tag="h5">Atenção!</Heading>
                    <p>
                        A data do seu voo é depois do dia <strong>{title}</strong>. Por isso, é possível que a alteração dessa passagem não siga as condições da companhia para cancelamento ou remarcação por coronavírus. <strong>Você pode seguir com a sua solicitação por aqui</strong>. Enviaremos o pedido para avaliação da companhia e manteremos você informado.
                    </p>
                    <Button
                        size="medium"
                        className={css`${buttonCustomStyle}`}
                        onClick={() => {
                            setModalOpen(false);
                            setIsFormOpen(!isFormOpen);
                        }}
                    >
                        Ok, entendi
                    </Button>
                </>
            </MaxModal>
        </>
    )
}

CancellationProtocol.propTypes = {
    title: PropTypes.string,
    isCorona: PropTypes.bool,
    noShow: PropTypes.bool,
    showAlertModal: PropTypes.bool,
}

CancellationProtocol.defaultProps = {
    title: '',
    isCorona: false,
    noShow: false,
    showAlertModal: false,
}

export default CancellationProtocol;